<div class="reasoning-container">
    <h3 class="reasoning-title">{{ title }}</h3>
    <p class="reasoning-guidelines">{{ guidelines }}</p>
    <mat-form-field appearance="outline" class="reasoning-field">
        <textarea
            matInput
            rows="6"
            [placeholder]="placeholderText"
            [(ngModel)]="text"
            (blur)="onBlur()"
        ></textarea>
    </mat-form-field>
</div>
